import React from 'react'

import { useTranslation } from 'react-i18next'

import { Render } from '@/components/render-if'
import { SectionGroup, SectionItem, SectionItemValue } from '@/components/ui'
import type { ParticipacaoResumo } from '@/features/proposta/brasil/domain/ResumoProposta/resumo-participacoes-imobiliarias'
import type { TPropostaSchemaInput } from '@/features/proposta/brasil/domain/schemas'
import { DetalhesPropostaResumoSection } from '@/features/proposta/shared/components/detalhes-proposta-resumo-section'

type TDetalhesPropostaSectionProps = {
  resumoParticipacao: readonly ParticipacaoResumo[]
  assinaturaContrato: TPropostaSchemaInput['detalhesDaProposta']['assinaturaContrato']
  termosDaProposta: string
  observacoes?: string
  onEdit: (step: number) => void
}

export function DetalhesPropostaSection({
  resumoParticipacao,
  assinaturaContrato,
  termosDaProposta,
  observacoes,
  onEdit,
}: Readonly<TDetalhesPropostaSectionProps>) {
  const { t } = useTranslation('proposta')

  return (
    <DetalhesPropostaResumoSection
      assinaturaContrato={assinaturaContrato}
      termosDaProposta={termosDaProposta}
      observacoes={observacoes}
      onEdit={onEdit}
    >
      <Render.If condition={!!resumoParticipacao.length}>
        {() => (
          <div className="space-y-3">
            <h3 className="font-poppins text-base font-normal uppercase">
              {t('resumo_proposta.detalhes_proposta.label.participacao_imobiliaria')}
            </h3>
            {resumoParticipacao.map((imobiliaria) => (
              <React.Fragment key={imobiliaria.id}>
                <SectionGroup withBorder>
                  <SectionItem label={t('resumo_proposta.detalhes_proposta.label.imobiliaria')}>
                    <SectionItemValue>{imobiliaria.nome}</SectionItemValue>
                  </SectionItem>
                </SectionGroup>
                <SectionGroup withBorder className="border-neutral-300">
                  <SectionItem label={imobiliaria.tipo} colSpan={4} withRightBorder>
                    <SectionItemValue>{imobiliaria.documento}</SectionItemValue>
                  </SectionItem>
                  <SectionItem
                    label={t('resumo_proposta.detalhes_proposta.label.participacao')}
                    colSpan={4}
                    withRightBorder
                  >
                    <SectionItemValue>{imobiliaria.participacao}</SectionItemValue>
                  </SectionItem>
                  <SectionItem label={t('resumo_proposta.detalhes_proposta.label.paga_por')} colSpan={4}>
                    <SectionItemValue>{imobiliaria.pagaPor}</SectionItemValue>
                  </SectionItem>
                </SectionGroup>
              </React.Fragment>
            ))}
          </div>
        )}
      </Render.If>
    </DetalhesPropostaResumoSection>
  )
}
